import axios from "axios";
import router from "@/router/index";
import env from "@/helpers/env";

let baseURL = env.base_url;
console.log(process.env.NODE_ENV);

// if (process.env.NODE_ENV === "production") {
//   baseURL = "https://sastra-backend.onrender.com/api";
// }

const axiosInstance = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      router.push("/login");
    }
    return Promise.reject(error);
  }
);

let token = localStorage.getItem("token");
if (token)
  axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${token}`;

export default axiosInstance;
